// ============================================================================
// SWAHILI TRANSLATIONS - BIBLE FACTS
// ============================================================================
// Ukweli wa kuvutia wa Biblia

export const bibleFacts = [
  {
    category: "takwimu",
    text: "Biblia ina jumla ya mistari 31,173",
    source: "Uchambuzi wa maandiko ya mikono"
  },
  {
    category: "lugha",
    text: "Biblia imetafsiriwa katika zaidi ya lugha 3000 tofauti",
    source: "Vyama vya Biblia Zilizounganishwa"
  },
  {
    category: "uandishi",
    text: "Biblia iliandikwa kwa miaka 1600 na waandishi 40 tofauti",
    source: "Masomo ya kihistoria ya Biblia"
  },
  {
    category: "muundo",
    text: "Zaburi 119 ndiyo sura ndefu zaidi yenye mistari 176",
    source: "Muundo wa kanoni"
  },
  {
    category: "rekodi",
    text: "Mstari mfupi zaidi kwa Kiswahili ni 'Yesu akalia' (Yohana 11:35)",
    source: "Uchambuzi wa maandiko"
  },
  {
    category: "ishara",
    text: "Nambari 7 inasimboliza ukamilifu na inaonekana mara 735",
    source: "Masomo ya nambari za Biblia"
  },
  {
    category: "msamiati",
    text: "Neno 'upendo' katika aina mbalimbali linaonekana zaidi ya mara 500",
    source: "Konkordansi ya Biblia"
  }
];

export default bibleFacts;
